import FormType from "../../Components/Form/FormType";
import Url from "../../Services/Url";

const AddTaskOptions = (task = {}) => {

	const options = {
		Fields: [
			{
				element: FormType.Select,
				required: true,
				name: "company",
				label: "Company",
				value: task.vessel
					? { id: task.vessel.company_id, name: task.vessel.company_name }
					: null,
				placeholder: "Select Company",
				options: {
					url: Url.company.allDTO,
					id: "id",
					name: "name",
				},
			},
			{
				element: FormType.Select,
				required: true,
				name: "vessel",
				label: "Vessel Name",
				value: task.vessel
					? { id: task.vessel.id, name: task.vessel.name }
					: null,
				placeholder: "Select Vessel",
				options: task.vessel
					? {
							url: Url.company.vesselDTO(task.vessel.company_id),
							id: "id",
							name: "name",
					  }
					: null,
			},
			{
				element: FormType.Input,
				required: true,
				type: "text",
				name: "location",
				label: "Location",
				placeholder: "Port",
				value: task.location || null,
			},
			[
				{
				element: FormType.Input,
				required: true,
				type: "text",
				name: "state",
				label: "State / Region",
				placeholder: "Enter state or region",
				value: task.state || "",
			},
			{
				element: FormType.Input,
				required: true,
				type: "text",
				name: "country",
				label: "Country",
				placeholder: "Enter country",
				value: task.country || "",
			},
			],
			[
				{
					element: FormType.Select,
					required: false,
					name: "taskOptions",
					label: "Bill Category",
					value: null,
					placeholder: "Select Category",
					options: [
						{ id: null, name: "Chargeable", chargeable: true },
						{ id: null, name: "Non Chargeable", chargeable: false },
					],
				},
				{
					element: FormType.Input,
					required: true,
					type: "date",
					name: "deliveryEstimate",
					label: "Delivery Estimate",
					placeholder: "Delivery Estimate",
					value: task.deliveryEstimate || null,
				},
			],
			{
				element: FormType.Input,
				required: false,
				type: "text",
				name: "serviceOrder",
				label: "Service Order/Case Number",
				placeholder: "Optional Service Order",
				value: task.serviceOrder || null,
			},
			{
				element: FormType.Input,
				required: false,
				type: "text",
				name: "budget",
				label: "Budget(₦)",
				placeholder: "Optional Budget",
				value: task.budget || null,
			},
		],
		Buttons: [
			{
				type: "button",
				text: "Cancel",
				className: "Btn-Mid",
				onClick: null,
			},
			{
				type: "submit",
				text: "Next",
				className: "Btn-Mid Active",
			},
		],
	};

	return options;
};

export default AddTaskOptions;
